import { AssistantPageKey } from './assistantContextTypes';

/**
 * Client-side page registry.
 *
 * Purely descriptive: it names the pages that have an adapter and what each is
 * called in the UI. It does NOT decide capabilities — the server registry is
 * the only authority on what a context may do, and the client's capability
 * list is a hint the backend replaces.
 */
export interface AssistantPageDescriptor {
  pageKey: AssistantPageKey;
  title: string;
  /** Capabilities the page believes apply. Advisory only. */
  candidateCapabilities: string[];
}

const REGISTRY: Record<AssistantPageKey, AssistantPageDescriptor> = {
  forecast_v3: {
    pageKey: 'forecast_v3',
    title: 'Forecast V3',
    candidateCapabilities: ['forecast.explain', 'forecast.review_accuracy', 'revenue.monthly_landing', 'forecast.update'],
  },
  journal_detail: {
    pageKey: 'journal_detail',
    title: 'Income Journal',
    // Read-only. There is deliberately no repair capability here: the server
    // decides what a journal context grants, and diagnosing an imbalance is
    // not the same as being allowed to correct one.
    candidateCapabilities: ['journal.explain', 'journal.diagnose_imbalance'],
  },
};

export function getPageDescriptor(pageKey: AssistantPageKey): AssistantPageDescriptor | null {
  return REGISTRY[pageKey] || null;
}

export function listPageKeys(): AssistantPageKey[] {
  return Object.keys(REGISTRY) as AssistantPageKey[];
}
